import type { ButtonBase } from "@shared/content-types/schemas/common.schema";

export const mockContactData = {
  title: "Контактная информация",
  content: {
    location: "Отель Rixos Krasnaya Polyana Sochi",
    coordinates: "42.662123, 43.839789",
    email1: "info@example.com",
    workingHours: "Пн-Пт: 9:00-18:00",
    phone: "+74951234567",
    email2: "support@example.com",
    socialLinks: [
      {
        name: "telegram",
        url: "https://t.me/example",
      },
      {
        name: "whatsapp",
        url: "https://wa.me/74951234567",
      },
    ],
    button: {
      link: "/contacts",
      text: "Подробнее",
      pageIcon: {
        icon: {
          name: "arrow-right",
        },
        fillColor: "azure",
        strokeColor: "white",
      },
    } as ButtonBase,
  },
};

export const mockContactData2 = {
  title: "Контактная информация",
  content: {
    location: "Москва, ул. Примерная, д. 123",
    coordinates: "42.662123, 43.839789",
    email1: "info@example.com",
    workingHours: "Пн-Пт: 9:00-18:00",
    phone: "+74951234567",
    email2: "support@example.com",
    socialLinks: [
      {
        name: "telegram",
        url: "https://t.me/example",
      },
      {
        name: "whatsapp",
        url: "https://wa.me/74951234567",
      },
    ],
    button: {
      link: "/contacts",
      text: "Подробнее",
      pageIcon: {
        icon: {
          name: "arrow-right",
        },
        fillColor: "azure",
        strokeColor: "white",
      },
    } as ButtonBase,
  },
};

export const minimalContactData = {
  title: "Базовые контакты",
  content: {
    location: "Санкт-Петербург, Невский пр., 1",
    email1: "contact@minimal.com",
  },
};

export const socialOnlyData = {
  title: "Социальные сети",
  content: {
    socialLinks: [
      {
        name: "facebook",
        url: "https://facebook.com/example",
      },
      {
        name: "instagram",
        url: "https://instagram.com/example",
      },
    ],
  },
};
